<template>
  <div class="credential flex flex-column">
    <div class="bg-white pad10-t pad10-lr mar10-tb">
      <!-- 提货码 -->
      <div v-if="!isBuyer">
        <p class="f14 gray3">提货码：</p>
        <div class="f18 fb flex justify-around pickup-code">
          <span v-for="(item, index) in order.codeList" :key="index">{{ item }}</span>
        </div>
      </div>
      <!-- 上传凭证 -->
      <div v-if="order.sellerVoucherImgUrl.length">
        <p class="gray3">卖家上传凭证（仅支持图片，最多5张）</p>
        <div class="pad5-tb imgList">
          <ul class="flex flex-wrap">
            <li v-for="(item, index) in order.sellerVoucherImgUrl" :key="index">
              <img :src="item" />
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="bg-white pad10 mar10-b flex items-center" v-if="order.takeGoodsNum">
      <span class="f14 gray3">提货单号：{{ order.takeGoodsNum }}</span>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {

  data() {
    return {
      orderId: "",
      order: {},
      isBuyer: true
    };
  },
  computed: mapState({
    userInfo: state => state.app.userInfo,
    userIdentity: state => state.app.userIdentity
  }),
  created() {
    const { id, isBuyer } = this.$route.query;
    this.orderId = id;
    this.isBuyer = isBuyer ? Number(isBuyer) : this.isBuyer;
    this.getCredential();
  },
  methods: {
    // 查看单卖家自提凭证审核
    getCredential() {
      const { orderId } = this;
      this.$store.dispatch("pickUp/getSellerCredential", {
        orderId
      }).then((data) => {
        this.order = data || {};
        this.order.codeList = this.order.pickupCode.split("");
      });
    }
  }
};
</script>
<style lang="scss" scoped>
  @import './style.scss';
</style>
